import { Form } from "components/Forms";
import { RichText } from "components/RichTextWidget";
import { buildWidgetInstanceId } from "features/widgets";
import { WIDGETS_REGISTRY } from "features/widgets/widgets.config";
import { useRouter } from "next/router";
import {
  Action,
  Container,
  Heading2,
  Icon,
  ModalWrapper,
  Paragraph,
} from "shared/components";
import { useToggle } from "shared/hooks";

import styles from "./Hero037.module.scss";

export const Hero037 = ({ payload }) => {
  const headline = payload?.headline ?? "";
  const description = payload?.description ?? "";
  const { buttonText, form, type, link } = payload?.request ?? {};

  const { query } = useRouter();
  const { opened, onOpen, onClose } = useToggle();

  const baseUrl = typeof window !== "undefined" ? window.location.origin : "";
  const externalLink =
    link?.startsWith("http") || link?.startsWith("https")
      ? link
      : `${baseUrl}${link}`;

  const instanceId = buildWidgetInstanceId(
    "037",
    payload.id,
    WIDGETS_REGISTRY.HERO
  );

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.content}>
          <Heading2 className={styles.headline} color="dark">
            {headline}
          </Heading2>
          {type === "external link" ? (
            <a
              href={externalLink}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.play}
            >
              <span className={styles.arrow}>
                <Icon className={styles.icon} name="arrow_right" />
              </span>
              <Paragraph color="brand">{buttonText}</Paragraph>
            </a>
          ) : (
            <Action onClick={onOpen} className={styles.play}>
              <span className={styles.arrow}>
                <Icon className={styles.icon} name="arrow_right" />
              </span>
              <Paragraph color="brand">{buttonText}</Paragraph>
            </Action>
          )}
          {opened && (
            <ModalWrapper onCloseModal={onClose}>
              <Form
                item={form}
                metaData={{ page: query.slug }}
                instanceId={instanceId}
                onReset={onClose}
              />
            </ModalWrapper>
          )}
        </div>
        <RichText
          value={description}
          className={styles.description}
          color="dark"
        />
      </Container>
    </div>
  );
};

export default Hero037;
